import { ContentBlock } from "eddev/blocks"
import { NativeLinkHandler } from "eddev/routing"

const HTMLBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

export default {
  // "core/paragraph": HTMLBlock,
  // "core/embed": (props) => {
  //   return <div>{JSON.stringify(props)}</div>
  // },
  "core/rich-text": (props: ContentBlock) => {
    return (
      <NativeLinkHandler
        as="div"
        className="rich-text-block wysiwyg basic-text-styles"
        dangerouslySetInnerHTML={{ __html: props.innerHTML ?? "" }}
      />
    )
  },
}
